
import venueRepo from '../services/venues';
import geocoder  from '../services/geocoder';

export const SHOW_EDIT_VENUE_OVERLAY       = 'SHOW_EDIT_VENUE_OVERLAY';
export const HIDE_EDIT_VENUE_OVERLAY       = 'HIDE_EDIT_VENUE_OVERLAY';
export const SHOW_DELETE_VENUE_OVERLAY     = 'SHOW_DELETE_VENUE_OVERLAY';
export const HIDE_DELETE_VENUE_OVERLAY     = 'HIDE_DELETE_VENUE_OVERLAY';
export const SHOW_NEW_VENUE_OVERLAY        = 'SHOW_NEW_VENUE_OVERLAY';
export const HIDE_NEW_VENUE_OVERLAY        = 'HIDE_NEW_VENUE_OVERLAY';
export const VENUES_REFRESHED              = 'VENUES_REFRESHED';
export const VENUE_LOCATION_RESOLVED       = 'VENUE_LOCATION_RESOLVED';

const addressToText = (address) => {

    return address.address_1 + ' ' + address.town_city + ' ' + address.post_code;
};

export function resolveAddressLocation(address) {

    return (dispatch) => {

        function resolutionSuccess(position) {

            dispatch(venueLocationResolved(position));
        }

        const addressText = addressToText(address);

        geocoder.addressToCoordinates(addressText)
            .then(resolutionSuccess);
    };
}

export function venueLocationResolved(location) {

    return {
        type: VENUE_LOCATION_RESOLVED,
        latitude: location.lat,
        longitude: location.lng
    };
}

export function showEditVenueOverlay(venue) {

    return {
        type: SHOW_EDIT_VENUE_OVERLAY,
        venue
    };
}

export function hideEditVenueOverlay() {

    return {
        type: HIDE_EDIT_VENUE_OVERLAY
    };
}

export function deleteVenue(venueId) {

    return (dispatch) => {

        function deleteSuccess() {

            dispatch(hideDeleteVenueOverlay());
            dispatch(refreshVenues());
        }

        venueRepo.remove(venueId)
            .then(deleteSuccess);
    };
}

export function hideDeleteVenueOverlay() {

    return {
        type: HIDE_DELETE_VENUE_OVERLAY
    };
}

export function showDeleteVenueOverlay(venue) {

    return {
        type: SHOW_DELETE_VENUE_OVERLAY,
        venue
    };
}

export function venuesRefreshed(venues) {

    return {
        type: VENUES_REFRESHED,
        venues
    };
}

export function refreshVenues() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(venuesRefreshed(response.data.data));
        }

        venueRepo.getAll()
            .then(getSuccess);
    };
}

export function hideNewVenueOverlay() {

    return {
        type: HIDE_NEW_VENUE_OVERLAY
    };
}

export function showNewVenueOverlay() {

    return {
        type: SHOW_NEW_VENUE_OVERLAY
    };
}


// WEBPACK FOOTER //
// ./actions/venueList.js